// // Free Shades Modal Logic
// (function() {
//   if (!window.FREE_SHADES_PRODUCT || !window.FREE_SHADES_THRESHOLD) return;
  
//   console.log(window.FREE_SHADES_PRODUCT, "product", window.FREE_SHADES_THRESHOLD, "threshold");
  
//   let modal, overlay, selectedVariants = [], variants = [], productData = null;
//   let isModalOpen = false;

//   // Initialize the modal system
//   function initModalSystem() {
//     // Create click handler for the "Add to cart - Free" button
//     document.addEventListener('click', function(e) {
//       if (e.target.closest('.add-to-cart-giftcontainer')) {
//         e.preventDefault();
//         openModal();
//       }
//     });

//     // Initialize product data
//     fetchProductData(window.FREE_SHADES_PRODUCT.handle || window.FREE_SHADES_PRODUCT)
//       .then(data => {
//         productData = data;
//         variants = data.variants;
//       });

//     // Start monitoring cart threshold
//     monitorCartThreshold();
//   }

//   // Monitor cart total and remove free shades if below threshold
//   function monitorCartThreshold() {
//     // Check immediately
//     checkCartThreshold();
    
//     // Also check on cart updates
//     document.addEventListener('cart:updated', checkCartThreshold);
//     setInterval(checkCartThreshold, 500); // Check every 5 seconds as fallback
//   }

//   async function checkCartThreshold() {
//     try {
//       const cartRes = await fetch('/cart.js');
//       const cart = await cartRes.json();
//       const cartTotal = cart.total_price / 100; // Convert to currency value
      
//       // Check if cart total is below threshold and has free shades
//       if (cartTotal < window.FREE_SHADES_THRESHOLD) {
//         const freeShadeItems = cart.items.filter(item => 
//           item.properties && item.properties._free_shade === 'true'
//         );
        
//         if (freeShadeItems.length > 0) {
//           console.log('Removing free shades as cart total is below threshold');
//           await removeFreeShadesFromCart();
//           await updateCartDrawer();
//         }
//       }
//     } catch (error) {
//       console.error('Error monitoring cart threshold:', error);
//     }
//   }

//   // Fetch product data
//   function fetchProductData(productId) {
//     return fetch(`/products/${productId}.js`).then(r => r.json());
//   }

//   // Create modal HTML
//   function createModal() {
//     overlay = document.createElement('div');
//     overlay.id = 'free-shades-overlay';
//     overlay.style = 'position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(0,0,0,0.25);z-index:9998;display:flex;align-items:center;justify-content:center;';
//     overlay.addEventListener('click', function(e) {
//       if (e.target === overlay) closeModal();
//     });

//     modal = document.createElement('div');
//     modal.id = 'free-shades-modal';
//     modal.style = 'background:#fff;max-width:650px;width:95vw;padding:0;border-radius:12px;box-shadow:0 8px 32px rgba(0,0,0,0.18);position:relative;z-index:9999;text-align:left;display:flex;flex-direction:column;align-items:stretch;overflow:hidden;';
//     modal.innerHTML = `
//       <button id="free-shades-close" style="position:absolute;top:18px;right:18px;background:none;border:none;font-size:22px;cursor:pointer;z-index:2;">&times;</button>
//       <div style="padding:32px 32px 0 32px;text-align:center;margin:0 auto;">
//         <h2 style="font-size:1.2em;font-weight:600;margin-bottom:4px;">Pick 2 Free Shades On Us!</h2>
//         <div style="margin-bottom:12px;font-size:1em;">Enjoy 2 shades free with your ₹${window.FREE_SHADES_THRESHOLD}+ order.</div>
//       </div>
//       <div style="display:flex;align-items:stretch;">
//         <div style="flex:0 0 220px;background:#f7f7f7;display:flex;align-items:center;justify-content:center;padding:32px 0 32px 32px;">
//           <div id="free-shades-product-img" style="width:140px;height:180px;display:flex;align-items:center;justify-content:center;"></div>
//         </div>
//         <div style="flex:1;padding:32px 32px 32px 24px;display:flex;flex-direction:column;justify-content:center;">
//           <div style="font-size:1.1em;font-weight:600;margin-bottom:8px;">${productData ? productData.title : ''}</div>
//           <div id="free-shades-swatches" style="display:flex;flex-wrap:wrap;margin-bottom:18px;"></div>
//           <div id="free-shades-selected" style="margin-bottom:18px;font-size:1em;"></div>
//           <button id="free-shades-add" style="padding:10px 32px;font-size:1em;border:1px solid #222;background:#fff;cursor:pointer;align-self:flex-start;">ADD TO CART - $0</button>
//         </div>
//       </div>
//     `;
//     overlay.appendChild(modal);
//     document.body.appendChild(overlay);

//     document.getElementById('free-shades-close').onclick = closeModal;
//     document.getElementById('free-shades-add').onclick = addToCart;
    
//     // Render modal content
//     renderProductImage();
//     renderSwatches();
//     renderSelectedNames();
//   }

//   // Render product image
//   function renderProductImage() {
//     if (!productData) return;
//     const imgDiv = document.getElementById('free-shades-product-img');
//     imgDiv.innerHTML = `<img src="${productData.images[0]}" alt="${productData.title}" style="max-width:100%;max-height:100%;object-fit:contain;"/>`;
//   }

//   // Render swatches
//   function renderSwatches() {
//     const swatchDiv = document.getElementById('free-shades-swatches');
//     if (!swatchDiv || !variants.length) return;
    
//     swatchDiv.innerHTML = '';
//     variants.forEach((variant) => {
//       let color = '#e6c1a2';
//       if (variant.option1) {
//         const colorName = variant.option1.split(' ')[0];
//         if (window.theme_custom_colors && window.theme_custom_colors[colorName]) {
//           color = window.theme_custom_colors[colorName];
//         }
//       }
      
//       const label = document.createElement('label');
//       label.className = 'shade-option';
//       label.style.margin = '4px';
//       label.innerHTML = `
//         <input type="checkbox" name="free-shades-variant" value="${variant.id}" 
//           ${selectedVariants.includes(variant.id) ? 'checked' : ''} style="display:none;">
//         <span class="shade-swatch" style="display:inline-block;width:28px;height:28px;
//           border-radius:50% 50% 50% 50% / 60% 60% 40% 40;background:${color};border:1px solid #ccc;vertical-align:middle;
//           ${selectedVariants.includes(variant.id) ? 'border-color:#000;box-shadow:0 0 0 2px #fff, 0 0 0 4px #000' : ''}">
//         </span>
//       `;
//       label.title = variant.title;
//       label.onclick = (e) => {
//         e.preventDefault();
//         toggleVariant(variant.id);
//       };
//       swatchDiv.appendChild(label);
//     });
//   }

//   // Render selected variant names
//   function renderSelectedNames() {
//     const selDiv = document.getElementById('free-shades-selected');
//     if (!selDiv) return;
    
//     if (selectedVariants.length === 0) {
//       selDiv.textContent = 'Select 2 shades';
//     } else {
//       const names = selectedVariants.map(id => {
//         const v = variants.find(v => v.id === id);
//         return v ? `<b>${v.title}</b>` : '';
//       });
//       selDiv.innerHTML = names.join(' & ');
//     }
//   }

//   // Toggle variant selection
//   function toggleVariant(variantId) {
//     if (selectedVariants.includes(variantId)) {
//       selectedVariants = selectedVariants.filter(id => id !== variantId);
//     } else {
//       if (selectedVariants.length >= 2) return;
//       selectedVariants.push(variantId);
//     }
//     renderSwatches();
//     renderSelectedNames();
//   }

//   // Update cart drawer
//   async function updateCartDrawer() {
//     const cartDrawer = document.querySelector('cart-drawer');
//     if (!cartDrawer) return;
    
//     try {
//       const response = await fetch('/?sections=cart-drawer,cart-icon-bubble');
//       const data = await response.json();
      
//       if (data['cart-drawer']) {
//         const tempDiv = document.createElement('div');
//         tempDiv.innerHTML = data['cart-drawer'];
//         const newDrawerInner = tempDiv.querySelector('.drawer__inner');
//         const drawerInner = cartDrawer.querySelector('.drawer__inner');
        
//         if (drawerInner && newDrawerInner) {
//           drawerInner.innerHTML = newDrawerInner.innerHTML;
//         }
        
//         if (typeof cartDrawer.refreshDrawer === 'function') {
//           cartDrawer.refreshDrawer();
//         }
//       }
      
//       if (data['cart-icon-bubble']) {
//         const cartBubble = document.getElementById('cart-icon-bubble');
//         if (cartBubble) {
//           cartBubble.innerHTML = data['cart-icon-bubble'];
//         }
//       }
//     } catch (error) {
//       console.error('Error updating cart drawer:', error);
//     }
//   }

//   // Open cart drawer
//   function openCartDrawer() {
//     const cartDrawer = document.querySelector('cart-drawer');
//     if (cartDrawer && typeof cartDrawer.open === 'function') {
//       cartDrawer.open();
//     }
//   }

//   // Add selected variants to cart
//   async function addToCart() {
//     if (selectedVariants.length !== 2) {
//       alert('Please select 2 shades.');
//       return;
//     }
    
//     try {
//       // Remove existing free shades first
//       await removeFreeShadesFromCart();
      
//       // Add new selected shades
//       await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           items: [
//             { id: selectedVariants[0], quantity: 1, properties: { '_free_shade': 'true' } },
//             { id: selectedVariants[1], quantity: 1, properties: { '_free_shade': 'true' } }
//           ]
//         })
//       });

//       closeModal();
//       await updateCartDrawer();
//       openCartDrawer();
      
//       // Dispatch cart updated event
//       document.dispatchEvent(new CustomEvent('cart:updated'));
//     } catch (error) {
//       console.error('Error adding free shades to cart:', error);
//     }
//   }

//   // Remove free shades from cart
//   function removeFreeShadesFromCart() {
//     return fetch('/cart.js').then(r => r.json()).then(cart => {
//       const freeShadeItems = cart.items.filter(item => 
//         item.properties && item.properties._free_shade === 'true'
//       );
//       if (freeShadeItems.length === 0) return Promise.resolve();
      
//       return Promise.all(freeShadeItems.map(item => {
//         return fetch('/cart/change.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ id: item.key, quantity: 0 })
//         });
//       }));
//     });
//   }

//   // Open modal
//   function openModal() {
//     if (isModalOpen) return;
//     isModalOpen = true;
    
//     // Remove existing modal if any
//     const existingOverlay = document.getElementById('free-shades-overlay');
//     if (existingOverlay) existingOverlay.remove();

//     // Get current free shades from cart
//     fetch('/cart.js').then(r => r.json()).then(cart => {
//       selectedVariants = cart.items
//         .filter(item => item.properties && item.properties._free_shade === 'true')
//         .map(item => item.variant_id);
      
//       createModal();
//     });
//   }

//   // Close modal
//   function closeModal() {
//     const overlayEl = document.getElementById('free-shades-overlay');
//     if (overlayEl) overlayEl.remove();
//     isModalOpen = false;
//   }

//   // Initialize
//   initModalSystem();
// })();


// Free Shades Modal Logic with Loading Spinner
(function() {
  if (!window.FREE_SHADES_PRODUCT || !window.FREE_SHADES_THRESHOLD) {
    console.warn('Free Shades: Required variables not set');
    return;
  }

  console.log('Free Shades: Initializing with product', window.FREE_SHADES_PRODUCT, 'and threshold', window.FREE_SHADES_THRESHOLD);
  
  // State variables
  let modal, overlay;
  let selectedVariants = [];
  let variants = [];
  let productData = null;
  let isModalOpen = false;

  // Initialize the modal system
  function init() {
    document.addEventListener('click', handleAddToCartClick);
    loadProductData();
    startCartMonitoring();
  }

  function handleAddToCartClick(e) {
    if (e.target.closest('.add-to-cart-giftcontainer')) {
      e.preventDefault();
      openModal();
    }
  }

  async function loadProductData() {
    try {
      const productHandle = window.FREE_SHADES_PRODUCT.handle || window.FREE_SHADES_PRODUCT;
      const response = await fetch(`/products/${productHandle}.js`);
      productData = await response.json();
      variants = productData.variants;
    } catch (error) {
      console.error('Free Shades: Error loading product data', error);
    }
  }

  function startCartMonitoring() {
    checkCartThreshold();
    document.addEventListener('cart:updated', checkCartThreshold);
  }

  async function checkCartThreshold() {
    try {
      const cart = await getCart();
      const cartTotal = cart.total_price / 100;
      
      if (cartTotal < window.FREE_SHADES_THRESHOLD) {
        const hasFreeShades = cart.items.some(item => 
          item.properties?._free_shade === 'true'
        );
        
        if (hasFreeShades) {
          console.log('Free Shades: Removing free shades - cart below threshold');
          await removeFreeShades();
          await updateCartUI();
        }
      }
    } catch (error) {
      console.error('Free Shades: Error checking cart threshold', error);
    }
  }

  async function getCart() {
    const response = await fetch('/cart.js');
    return await response.json();
  }

  function createModal() {
    if (overlay) overlay.remove();
    
    overlay = document.createElement('div');
    overlay.id = 'free-shades-overlay';
    overlay.style = 'position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(0,0,0,0.25);z-index:9998;display:flex;align-items:center;justify-content:center;';
    overlay.addEventListener('click', (e) => e.target === overlay && closeModal());

    modal = document.createElement('div');
    modal.id = 'free-shades-modal';
    modal.style = 'background:#fff;max-width:650px;width:95vw;padding:0;border-radius:12px;box-shadow:0 8px 32px rgba(0,0,0,0.18);position:relative;z-index:9999;text-align:left;display:flex;flex-direction:column;align-items:stretch;overflow:hidden;';
    modal.innerHTML = `
      <button id="free-shades-close" style="position:absolute;top:18px;right:18px;background:none;border:none;font-size:22px;cursor:pointer;z-index:2;">&times;</button>
      <div style="padding:20px 10px 0 20px;text-align:center;margin:0 auto;">
        <h2 style="font-size:1.2em;font-weight:600;margin-bottom:4px;">Pick 2 Free Shades On Us!</h2>
        <div style="margin-bottom:12px;font-size:1em;">Enjoy 2 shades free with your ₹${window.FREE_SHADES_THRESHOLD}+ order.</div>
      </div>
      <div style="display:flex;align-items:stretch;">
        <div style="flex:0 0 220px;background:#f7f7f7;display:flex;align-items:center;justify-content:center;padding:32px 0 32px 32px;">
          <div id="free-shades-product-img" style="width:140px;height:180px;display:flex;align-items:center;justify-content:center;"></div>
        </div>
        <div style="flex:1;padding:32px 32px 32px 24px;display:flex;flex-direction:column;justify-content:center;">
          <div style="font-size:1.1em;font-weight:600;margin-bottom:8px;">${productData?.title || ''}</div>
          <div id="free-shades-swatches" style="display:flex;flex-wrap:wrap;margin-bottom:18px;"></div>
          <div id="free-shades-selected" style="margin-bottom:18px;font-size:1em;"></div>
          <button id="free-shades-add" style="padding:10px 32px;font-size:1em;border:1px solid #222;background:#fff;cursor:pointer;align-self:flex-start;position:relative;">
            <span class="button-text">ADD TO CART - $0</span>
            <span class="loading-spinner" style="display:none;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);">
              <svg style="width:20px;height:20px;animation:spin 0.8s linear infinite;" viewBox="0 0 24 24">
                <path fill="currentColor" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z"/>
              </svg>
            </span>
          </button>
        </div>
      </div>
    `;
    
    overlay.appendChild(modal);
    document.body.appendChild(overlay);

    document.getElementById('free-shades-close').onclick = closeModal;
    document.getElementById('free-shades-add').onclick = addSelectedToCart;
    
    renderModalContent();
  }

  function renderModalContent() {
    if (!productData) return;
    
    const imgDiv = document.getElementById('free-shades-product-img');
    imgDiv.innerHTML = `<img src="${productData.images[0]}" alt="${productData.title}" style="max-width:100%;max-height:100%;object-fit:contain;"/>`;
    
    renderSwatches();
    renderSelectedText();
  }

  function renderSwatches() {
    const swatchDiv = document.getElementById('free-shades-swatches');
    if (!swatchDiv || !variants.length) return;
    
    swatchDiv.innerHTML = '';
    
    variants.forEach(variant => {
      const color = getVariantColor(variant);
      const isSelected = selectedVariants.includes(variant.id);
      
      const swatch = document.createElement('label');
      swatch.className = 'shade-option';
      swatch.style.margin = '4px';
      swatch.title = variant.title;
      swatch.innerHTML = `
        <input type="checkbox" name="free-shades-variant" value="${variant.id}" 
          ${isSelected ? 'checked' : ''} style="display:none;">
        <span class="shade-swatch" style="display:inline-block;width:28px;height:28px;
          border-radius:50% 50% 50% 50% / 60% 60% 40% 40;background:${color};border:1px solid #ccc;vertical-align:middle;
          ${isSelected ? 'border-color:#000;box-shadow:0 0 0 2px #fff, 0 0 0 4px #000' : ''}">
        </span>
      `;
      swatch.onclick = (e) => {
        e.preventDefault();
        toggleVariantSelection(variant.id);
      };
      swatchDiv.appendChild(swatch);
    });
  }

  function getVariantColor(variant) {
    if (!variant.option1) return '#e6c1a2';
    const colorName = variant.option1.split(' ')[0];
    return window.theme_custom_colors?.[colorName] || '#e6c1a2';
  }

  function toggleVariantSelection(variantId) {
    if (selectedVariants.includes(variantId)) {
      selectedVariants = selectedVariants.filter(id => id !== variantId);
    } else {
      if (selectedVariants.length >= 2) return;
      selectedVariants.push(variantId);
    }
    renderSwatches();
    renderSelectedText();
  }

  function renderSelectedText() {
    const selDiv = document.getElementById('free-shades-selected');
    if (!selDiv) return;
    
    selDiv.innerHTML = selectedVariants.length === 0 
      ? 'Select 2 shades'
      : selectedVariants.map(id => {
          const variant = variants.find(v => v.id === id);
          return variant ? `<b>${variant.title}</b>` : '';
        }).join(' & ');
  }

  async function addSelectedToCart() {
    if (selectedVariants.length !== 2) {
      alert('Please select exactly 2 shades.');
      return;
    }
    
    const addButton = document.getElementById('free-shades-add');
    if (!addButton) return;
    
    // Show loading spinner
    const buttonText = addButton.querySelector('.button-text');
    const spinner = addButton.querySelector('.loading-spinner');
    
    buttonText.style.visibility = 'hidden';
    spinner.style.display = 'block';
    addButton.disabled = true;
    
    try {
      await removeFreeShades();
      
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            { id: selectedVariants[0], quantity: 1, properties: { '_free_shade': 'true' } },
            { id: selectedVariants[1], quantity: 1, properties: { '_free_shade': 'true' } }
          ]
        })
      });

      closeModal();
      await updateCartUI();
      openCartDrawer();
      
      document.dispatchEvent(new CustomEvent('cart:updated'));
    } catch (error) {
      console.error('Free Shades: Error adding to cart', error);
      alert('Failed to add free shades to cart. Please try again.');
    } finally {
      // Hide loading spinner
      if (buttonText) buttonText.style.visibility = 'visible';
      if (spinner) spinner.style.display = 'none';
      if (addButton) addButton.disabled = false;
    }
  }

  async function removeFreeShades() {
    try {
      const cart = await getCart();
      const freeShadeItems = cart.items.filter(item => 
        item.properties?._free_shade === 'true'
      );
      
      if (freeShadeItems.length === 0) return;
      
      await Promise.all(freeShadeItems.map(item => 
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 0 })
        })
      ));
    } catch (error) {
      console.error('Free Shades: Error removing free shades', error);
      throw error;
    }
  }

  async function updateCartUI() {
    try {
      const response = await fetch('/?sections=cart-drawer,cart-icon-bubble');
      const data = await response.json();
      
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && data['cart-drawer']) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = data['cart-drawer'];
        const newContent = tempDiv.querySelector('.drawer__inner');
        if (newContent) {
          cartDrawer.querySelector('.drawer__inner').innerHTML = newContent.innerHTML;
        }
        if (typeof cartDrawer.refreshDrawer === 'function') {
          cartDrawer.refreshDrawer();
        }
      }
      
      const cartBubble = document.getElementById('cart-icon-bubble');
      if (cartBubble && data['cart-icon-bubble']) {
        cartBubble.innerHTML = data['cart-icon-bubble'];
      }
    } catch (error) {
      console.error('Free Shades: Error updating cart UI', error);
    }
  }

  function openCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer?.open) cartDrawer.open();
  }

  function openModal() {
    if (isModalOpen) return;
    isModalOpen = true;
    
    getCart().then(cart => {
      selectedVariants = cart.items
        .filter(item => item.properties?._free_shade === 'true')
        .map(item => item.variant_id);
      
      createModal();
    }).catch(error => {
      console.error('Free Shades: Error opening modal', error);
      isModalOpen = false;
    });
  }

  function closeModal() {
    if (overlay) overlay.remove();
    isModalOpen = false;
  }

  // Add CSS for spinner animation
  const style = document.createElement('style');
  style.textContent = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;
  document.head.appendChild(style);

  // Initialize
  document.addEventListener('DOMContentLoaded', init);
})();
